import Footer from "components/sections/home/HomeFooter";
import Navbar from "components/Navbar";
import PageHeader from "components/PageHeader";
import AboutUs from "components/sections/about/AboutUs";
import HeroSection from "components/sections/about/HeroSection";
import Team from "components/sections/about/Team";
import Map from "components/Map";
import { useEffect } from "react";

const About = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  return (
    <main>
      <PageHeader title="About us | Smartcomply" />
      <Navbar />
      <HeroSection />
      <div className="bg-[linear-gradient(8.3deg,#FFFFFF_55.89%,#E5F0FF_100.6%)] max-md:bg-[linear-gradient(8.3deg,#FFFFFF_90.89%,#E5F0FF_100.6%)] bg-white">
        <AboutUs />
        <Team />
      </div>

      <Map />
      <Footer />
    </main>
  );
};

export default About;
